import React from 'react';
import SEO from '../components/SEO';

const Terms: React.FC = () => {
  return (
    <>
      <SEO
        title="Terms & Conditions - SpinHarvester"
        description="Read our terms and conditions for using SpinHarvester.com. Understand your rights and responsibilities when using our casino review platform."
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Terms and Conditions'
        }}
      />

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Terms & Conditions</h1>
          <p className="text-gray-600 mb-8">Last updated: {new Date().toLocaleDateString('en-GB')}</p>

          <div className="bg-white rounded-xl shadow-lg p-8 prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Welcome to SpinHarvester.com. These Terms and Conditions govern your use of our website and services. 
                By accessing or using our website, you agree to be bound by these terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Eligibility</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                You must be at least 18 years old to use this website. By using our services, you confirm that you are 
                of legal gambling age in your jurisdiction and that you are legally permitted to access online gambling 
                information and services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Use of Website</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                SpinHarvester provides information, reviews, and comparisons of UK-licensed online casinos. Our content 
                is for informational purposes only and should not be considered as legal, financial, or professional 
                gambling advice.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Affiliate Relationships</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                SpinHarvester may receive commissions from casinos when users sign up through our links. This does not 
                influence our reviews or recommendations. We maintain editorial independence and provide honest, 
                unbiased information.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Responsible Gambling</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We promote responsible gambling. If you feel you may have a gambling problem, please seek help from 
                organizations such as GamCare, BeGambleAware, or Gambling Therapy. We provide links to these resources 
                throughout our website.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Intellectual Property</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                All content on SpinHarvester.com, including text, graphics, logos, and images, is the property of 
                SpinHarvester or its content suppliers and is protected by copyright and other intellectual property laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                SpinHarvester is not responsible for any losses or damages resulting from your use of information on 
                this website or your interactions with third-party casinos. We provide information "as is" without 
                warranties of any kind.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Changes to Terms</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We reserve the right to modify these terms at any time. Changes will be posted on this page with an 
                updated revision date. Your continued use of the website constitutes acceptance of any changes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Contact</h2>
              <p className="text-gray-700 leading-relaxed">
                If you have questions about these Terms and Conditions, please contact us through our website.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;


